import axios from 'axios'
import { atom } from 'jotai'
import * as XLSX from 'xlsx'

import { settingsState } from './settingsState'

export const excelState = atom(async get => {
  const settings = await get(settingsState)
  const url = `./spec/${settings.dataFile}`

  return new Promise<string[][]>((resolve, reject) => {
    axios
      .get(url, { responseType: 'arraybuffer' })
      .then(res => {
        const workBook = XLSX.read(res.data, {})
        const workSheet = workBook.Sheets[workBook.SheetNames[0]]

        const data: string[][] = XLSX.utils.sheet_to_json<string[]>(workSheet, {
          // header: 'A',
          // header: ['moge', 'mogemoge'],
          header: 1,
          // header: 2,
          // header: 3,
          // rawNumbers: true,
        })

        // 全セルを文字列に正規化（数値型やスパース配列のundefined対策）
        const normalizedData = data.map(row =>
          Array.from({ length: row.length }, (_, i) => String(row[i] ?? ''))
        )

        resolve(normalizedData)
      })
      .catch(err => {
        reject(err)
      })
  })
  // }
})

// いらなそう
// export const sheetState = atom(excelState)
